<template>
    <div class="Hosting">
        <div class="row">
            <div class="col">
                <div class="record-section">
                    <h3>LIFETIME HOSTING HISTORY</h3>
                    <table class="table-utility">
                        <thead>
                            <tr>
                                <th>Child</th>
                                <th>Host Family</th>
                                <th>Started</th>
                                <th>Ended</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="hosting in Hostings">
                                <td>{{ hosting.Client.Person.FullName }}</td>
                                <td>{{ hosting.FosterResourceFamily.Name }}</td>
                                <td>{{ formatDate(hosting.StartDate, 'MM/DD/YY') }}</td>
                                <td>{{ formatDate(hosting.EndDate, 'MM/DD/YY') }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    //Import Components

    export default {
        name: "HostingHistory",
        props: [
            'CommunityFamilyId'
        ],
        data: function () {
            return {
                Hostings: [],
            }
        },
        methods: {
            //API
           
            GetHostings() {
                this.$MasterAPI.ExecuteRequest("GET", "StrongFamilies/Hostings", { CommunityFamilyID: this.CommunityFamilyId }, this.GetHostingsSuccess, () => { }, true);
            },
            GetHostingsSuccess(response) {
                this.Hostings = response.data.data;
            },
            //UI

            //AUX
            formatDate (value, fmt = 'MM/DD/YY', defaultText = '') {
              return (value == null)
                ? defaultText
                : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            
        },
        components: {
            
        },
        mounted() {
            this.GetHostings();
        },
        computed: {
            
        }
    }
</script>

<style scoped>
</style>